const extractFields = (fields) => {
  let result = [];

  fields.forEach((field) => {
    if (field.subFields) {
      result.push(field.name);
      result = result.concat(extractFields(Object.values(field.subFields)));
    }
  });

  return result;
};

const getFieldsWithSubFields = (fields) => {
  const result = new Set(extractFields(fields));

  return Array.from(result);
};

export default getFieldsWithSubFields;
